import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "common/hooks/useAuth";
import ObservationGroupForm from "./ObservationGroupForm";

function ObservationGroup() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "observation-groups",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/observation-groups");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataObservationGroup: any) => {
      const newObservationGroup = { ...dataObservationGroup };

      try {
        if (newObservationGroup.id) {
          await updateItem(newObservationGroup.id, newObservationGroup);
        } else {
          await saveItem(newObservationGroup);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <ObservationGroupForm onSubmit={onSubmit} observationGroup={item} />
  );
}

export default ObservationGroup;
